<div class="ficha-veiculo-em-seu-nome">
  <form [formGroup]="form">
    <div class="row">
      <div class="form-group">
        <span class="icon pesado"></span>
        <div class="inputs field-group">
          <div class="switch-row field-group__pesados">
            <div class="switch-group">
              <app-switch
                id="veiculo-veiculoEmMeuNome"
                name="veiculoEmMeuNome"
                formControlName="isVeiculoEmMeuNome">
              </app-switch>
              <span class="radio-label">Possui veículo em seu nome?</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row form-group pb0 ficha-veiculo-em-seu-nome_title"
      *ngIf="isVeiculoEmMeuNome && labelTitle">
      <span>{{ labelTitle }}</span>
    </div>

    <div
      class="blue-box new-car"
      [ngClass]="{'dn': !isVeiculoEmMeuNome}">
      <div class="row">
        <div class="form-group pb0" [ngClass]="{'dn': isPlacaOpcional}">
          <span class="icon car"></span>
          <div class="inputs">
            <label
              [ngClass]="{'dn': isNaoSeiPlaca}"
              for="veiculoPlaca">
              Placa do Veículo
            </label>
            <input
              [ngClass]="{'dn': isNaoSeiPlaca}"
              type="text"
              class="form-control"
              id="veiculoPlaca"
              placeholder="BRA0S17"
              license-plate
              duplicidadeMessage="Placa duplicada"
              formControlName="veiculoPlaca"
              [licensePlateCheck]="veiculoPlaca"
              appShowErrorMessages>
            <div class="switch-row field-group__pesados">
              <div class="switch-group">
                <app-switch
                  id="veiculo-naoSeiPlaca"
                  name="naoSeiPlaca"
                  (change)="onClickNaoSeiPlaca()"
                  formControlName="isNaoSeiPlaca">
                </app-switch>
                <span class="radio-label">Não sei a placa</span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group pb0" [ngClass]="{'dn': !isNaoSeiPlaca}">
          <span class="icon"></span>
          <div class="inputs">
            <label for="categoria-veiculo">Categoria do Veículo</label>
            <select
              formControlName="veiculoCategoria"
              appShowErrorMessages
              [hidden]="!isLoadingTipoVeiculo"
              requiredMessage="O Campo Categoria é obrigatório"
              class="form-control"
              name="categoria-veiculo"
              (change)="onChangeTipoVeiculo($event)"
              (blur)="onBlurTipoVeiculo($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let tv of listaTipoVeiculo" value="{{ tv.id }}">{{ tv.descricao }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedTipoVeiculoAfterBlur">Categoria do Veículo é obrigatória</div>
            <span *ngIf="isLoadingTipoVeiculo">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0" [ngClass]="{'dn': !isNaoSeiPlaca}">
          <span class="icon"></span>
          <div class="inputs">
            <label for="marca-veiculo">Marca do Veículo</label>
            <select
              formControlName="veiculoMarca"
              name="marca-veiculo"
              appShowErrorMessages
              [hidden]="!isLoadingMarca"
              class="form-control"
              requiredMessage="O Campo Marca do Veículo é obrigatório"
              (change)="onChangeMarca($event)"
              (blur)="onBlurMarca($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let ma of listaMarca" value="{{ ma.id }}">{{ ma.descricao }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedMarcaAfterBlur && !isLoadingMarca">Marca do Veículo é obrigatória</div>
            <span *ngIf="isLoadingMarca">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0" [ngClass]="{'dn': !isNaoSeiPlaca}">
          <span class="icon"></span>
          <div class="inputs">
            <label for="ano-veiculo">Ano do Veículo</label>
            <select
              formControlName="veiculoAno"
              name="ano-veiculo"
              [hidden]="!isLoadingAnoModelo"
              requiredMessage="O Campo Ano do Veículo é obrigatório"
              id="vehicle-model-year"
              class="form-control"
              (change)="onChangeAnoModelo($event)"
              appShowErrorMessages
              (blur)="onBlurAnoModelo($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let am of listaAnoModelo" value="{{ am.anoModelo }}">{{ am.anoModelo }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedAnoModeloAfterBlur">Ano Modelo do Veículo é obrigatório</div>
            <span *ngIf="isLoadingAnoModelo">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0" [ngClass]="{'dn': !isNaoSeiPlaca}">
          <span class="icon"></span>
          <div class="inputs">
            <label for="modelo-veiculo">Modelo do Veículo</label>
            <select
              formControlName="veiculoModelo"
              name="modelo-veiculo"
              [hidden]="!isLoadingModelo"
              id="vehicle-model"
              requiredMessage="O Campo Modelo do Veículo é obrigatório"
              class="form-control"
              appShowErrorMessages
              (change)="onChangeModelo($event)"
              (blur)="onBlurModelo($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let mo of listaModelo" value="{{ mo.id }}">{{ mo.descricao }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedModeloAfterBlur">Modelo do Veículo é obrigatório</div>
            <span *ngIf="isLoadingModelo">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0" [ngClass]="{'dn': !isNaoSeiPlaca}">
          <span class="icon"></span>
          <div class="inputs">
            <label for="versao-veiculo">Versão do Veículo</label>
            <select
              formControlName="veiculoVersao"
              name="versao-veiculo"
              id="vehicle-version"
              class="form-control"
              appShowErrorMessages
              requiredMessage="O Campo Versão do Veículo é obrigatório"
              (change)="onChangeVersao($event)"
              (blur)="onBlurVersao($event)">
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let ve of listaVersao" value="{{ ve.id }}">{{ ve.descricao }}</option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedVersaoAfterBlur">Versão do Veículo é obrigatória</div>
            <span *ngIf="isLoadingVersao">
              <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
          </div>
        </div>

        <div class="form-group pb0" [ngClass]="{'dn': !isPlacaOpcional}">
          <span class="icon"></span>
          <div class="inputs">
            <label
              for="veiculoPlaca">
              Placa (opcional)
            </label>
            <input
              type="text"
              class="form-control"
              id="veiculoPlaca"
              placeholder="Digite a placa aqui"
              license-plate
              duplicidadeMessage="Placa duplicada"
              formControlName="veiculoPlaca"
              [licensePlateCheck]="veiculoPlaca"
              appShowErrorMessages>
          </div>
        </div>
      </div>
    </div>
  </form>

  <app-modal-message #modalMessage [title]="'Atenção!'"></app-modal-message>
</div>
